import Blue from "~/core";

new Blue({
	name: 'Form Validate',
	selector: ".form--validate",
	setup(form) {
		this.$validate(form);
	}
});

new Blue({
	name: 'Flow Form',
	selector: ".flow-form",
	setup(form) {
		const targetSpans = form.querySelectorAll('span');
		Array.prototype.forEach.call(targetSpans, function(element){
			element.removeAttribute('style');
		});
	}
});
